export * from './none-form/none-form.component';
export * from './condition-form/condition-form.component';
export * from './assignment-form/assignment-form.component';
export * from './example-docs/example-docs.component';
export * from './elaborate/elaborate.component';
export * from './approve/approve.component';
export * from './radication/radication.component';
export * from './dynamic-forms/dynamic-forms.component';
export * from './liquidation-determination/liquidation-determination.component';
export * from './project-liquidation/project-liquidation.component';
export * from './instance-liquidation/instance-liquidation.component';
export * from './attached/attached.component';
export * from './publication/publication.component';
export * from './document-inventory-form/document-inventory-form.component';
export * from './document-exp-inventory-form/document-exp-inventory-form.component';
export * from './modify-document/modify-document.component';
export * from './approve-modify-document/approve-modify-document.component';



// WEBPACK FOOTER //
// ./src/app/forms/all/index.ts